import * as React from 'react'

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { observer } from 'mobx-react'

interface IProps {
  isExpanded: boolean
  visibleElements: JSX.Element[]
  overflowElementsCount: number

  containerRefSetter(elementRef: HTMLElement): void
  measureSizeFn?(): void
  setExpandedState(): void
}

@observer
export default class ExpandableCardAttributeValues extends React.Component<IProps> {
  public componentDidMount(): void {
    requestAnimationFrame(() => {
      this.props.measureSizeFn?.()
    })
  }

  public componentDidUpdate(): void {
    requestAnimationFrame(() => {
      this.props.measureSizeFn?.()
    })
  }

  public render() {
    const { containerRefSetter, visibleElements, overflowElementsCount } =
      this.props

    return (
      <div className="row y-end">
        <div
          className="row wrap no-flex-children overflow-hidden relative"
          ref={containerRefSetter}
        >
          {visibleElements}
          {this.renderExpandableArrow(overflowElementsCount)}
        </div>
      </div>
    )
  }

  private renderExpandableArrow = (
    overflowElementsCount: number,
  ): JSX.Element => {
    const { isExpanded, setExpandedState } = this.props
    const ChevronIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon

    if (!isExpanded && !overflowElementsCount) {
      return null
    }

    return (
      <div
        className="absolute bg-white row no-flex expandable-arrow"
        onClick={this.stopPropagation}
      >
        <span
          className="pointer text blue-highlight br-rounded"
          onClick={setExpandedState}
        >
          <ChevronIcon size={16} className="tw:block" />
        </span>
      </div>
    )
  }

  private stopPropagation = (ev: React.SyntheticEvent) => {
    ev.stopPropagation()
  }
}
